export default "__VITE_ASSET__DWYkj4N1__"